import { FilterDto, FilterOptionDto } from '@act/shared/data-transfer-objects';
import { Fragment } from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';
import { ControlledAutocomplete } from '@act/storybook';
import ControlledRadioSelect from 'toolkit/inputs/controlled-radio-select';
import { Box } from '@mui/material';

interface FilterDialogProps<TFieldValues extends FieldValues = FieldValues> {
  filter: FilterDto;
  control: Control<TFieldValues>;
}

const FilterDialog = function <T>({ filter, control }: FilterDialogProps<T>) {
  return (
    <Fragment key={filter.name}>
      {filter.type != 'radio' && (
        <Box sx={{ pt: 2 }}>
          <ControlledAutocomplete
            name={`${filter.key}` as Path<T>}
            control={control}
            options={filter.filterOptions}
            getOptionLabel={(o: FilterOptionDto) => o?.label}
            label={`Filter by ${filter.name}`}
            multiple={true}
            limitTags={2}
            placeholder="Select an option"
          />
        </Box>
      )}
      {filter.type == 'radio' && (
        <ControlledRadioSelect
          control={control}
          row={true}
          name={`${filter.key}` as Path<T>}
          options={filter.filterOptions}
          label={`Filter by ${filter.name}`}
          getOptionLabel={(o: FilterOptionDto) => o?.label}
        />
      )}
    </Fragment>
  );
};

export default FilterDialog;
